export const POPUP_CONTROLLER = 'popup'
export const FLOW_CONTROLLER = 'flow'
export const PAGE_CONTROLLER = 'page'
export const FLOW_EDIT_CONTROLLER = 'flow-edit'
export const JSON_UPDATE_CONTROLLER = 'json-update'
export const CONDITIONAL_TAGS_CONTROLLER = 'conditional-tags'

export const CONTROLLERS = {
  popup: POPUP_CONTROLLER,
  flow: FLOW_CONTROLLER,
  page: PAGE_CONTROLLER,
  flowEdit: FLOW_EDIT_CONTROLLER,
  jsonUpdate: JSON_UPDATE_CONTROLLER,
  conditionalTags: CONDITIONAL_TAGS_CONTROLLER,
} as const

export type ControllerKey = keyof typeof CONTROLLERS
export type ControllerValue = (typeof CONTROLLERS)[ControllerKey]
